import {Component, OnInit} from '@angular/core';
import {APP_VERSION} from '../../../../../environments/environment';

@Component({
    selector: 'app-main-footer',
    templateUrl: './app-main-footer.component.html',
    styleUrls: ['./app-main-footer.component.scss'],
    standalone: false
})
export class AppMainFooterComponent implements OnInit {

  currentYear = new Date().getFullYear();

  protected readonly APP_VERSION = APP_VERSION;
  ngOnInit(): void {
  }
}
